import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './style/main.scss';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';



import {
    ApolloProvider,
    ApolloClient,
    createHttpLink,
    InMemoryCache, split
} from '@apollo/client';
import {getMainDefinition} from "@apollo/client/utilities";
import {WebSocketLink} from "@apollo/client/link/ws";
import {GraphQLWsLink} from "@apollo/client/link/subscriptions";
import {createClient} from "graphql-ws";

const container = document.getElementById('root')!;
const root = createRoot(container);

const host = process.env.REACT_APP_BACKEND ?? window.location.host;
const secure = window.location.protocol === 'https:';

const httpLink = createHttpLink({
    uri: `${secure ? 'https' : 'http'}://${host}/graphql`
});

const wsLink = new GraphQLWsLink(
    createClient({
        url: `${secure ? 'wss' : 'ws'}://${host}/graphql`,
        connectionParams: () => ({
            authToken: localStorage.getItem('AUTH_TOKEN'),   // Schlüssel an deinen Code anpassen
        }),
        retryAttempts: Infinity,
    })
);


const splitLink = split(
    ({ query }) =>
    {
        const definition = getMainDefinition(query);
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        );
    },
    wsLink,
    httpLink
);

const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache()
});


root.render(
    <ApolloProvider client={client}>
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>
    </ApolloProvider>
);

// If you want to start measuring performance in your redux, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
